import React from "react";
import styled from "styled-components";

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #832729;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-size: 100vw 100vh;
`;
const LoginContainer = styled.div`
  margin-top: 250px;
  width: 583.2px;
  height: 414.5px;
  padding: 28px 71.2px 37px 71.5px;
  border-radius: 19.6px;
  background-color: #ffffff;
`;
const AppLogo = styled.span`
  position: absolute;
  font-size: 32px;
  margin-top: 100px !important;
  display: block;
  color: #ffbc12;
  font-weight: bold;
`;
const Header = styled.div`
  text-align: center;
  font-size: 22px;
  font-family: Roboto,serif !important;
  color: #832729;
  margin-bottom: 25px;
`;
const PasswordInput = styled.input`
  width: 440px;
  height: 59px;
  margin: 20px 0.5px 0px 0;
  padding: 21.5px 15px 21.5px 12.4px;
  border-radius: 8px;
  border: solid 1.3px #bab7b7;
  outline: #ffbc12;
`;
const EmailInput = styled.input`
  width: 440px;
  height: 59px;
  margin: 20px 0.5px 10px 0;
  padding: 21.5px 15px 21.5px 12.4px;
  border-radius: 8px;
  border: solid 1.3px #bab7b7;
  outline: #ffbc12;
`;
const LoginButton = styled.button`
  width: 440px;
  height: 42px;
  margin: 38px 0.5px 0px 0;
  border-radius: 4.4px;
  border: solid 0.6px #ffbc12;
  background-color: #ffbc12;
  text-align: center;
  color: #ffffff;
  font-size: 18px;
  font-weight: bold;
`;

function LoginComponent(props) {
  const { state, onChangeEvent, onLoginClicked } = props;
  return (
    <MainContainer>
      <AppLogo>My Gold Work</AppLogo>
      <LoginContainer>
        <Header>
          <b>LOGIN TO YOUR ACCOUNT</b>
        </Header>
        <EmailInput
          type="text"
          placeholder="Email Address"
          id="email"
          required={true}
          value={state ? state.email : ""}
          onChange={onChangeEvent}
        />
        {state.emailError && (
          <div className="fc-red fs-12">{state.emailError}</div>
        )}

        <PasswordInput
          type="password"
          placeholder="Password"
          id="password"
          required={true}
          value={state ? state.password : ""}
          onChange={onChangeEvent}
        />
        {state.passwordError && (
          <div className="fc-red fs-12">{state.passwordError}</div>
        )}

        <LoginButton type="button" onClick={() => onLoginClicked()}>
          LOGIN
        </LoginButton>
      </LoginContainer>
    </MainContainer>
  );
}

export default LoginComponent;
